import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import "../../css/style.css";

import $ from "jquery";
import Constant from "../Constant";

const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};

class AddSimpleBanner extends Component {
  /*..................................... default state object ............................................*/
  state = {
    name: "",
    description: "",
    image: null,
    mobileImageFile: null,
    mobileImageUrl: "",
    link: "", // Link is now optional
    bannerData: {},
    ERROR: true,
    errors: {}, // Add for validation
  };

  validateForm = () => {
    const errors = {};
    const { name, description, link, image, bannerData } = this.state;
    const isEditing = Boolean(this.props.match.params.id);

    // For editing, use existing values if not changed
    const nameToValidate = name || bannerData.name || "";
    const descriptionToValidate = description || bannerData.description || "";
    const linkToValidate = link || bannerData.link || "";
    const ImagetoValidate = image || bannerData.image || "";

    if (!nameToValidate.trim()) {
      errors.name = "Name is required";
    }

    if (!descriptionToValidate.trim()) {
      errors.description = "Description is required";
    }

    if (!ImagetoValidate) {
      errors.image = "image is required";
    }
    if (!linkToValidate.trim()) {
      errors.link = "Link is required";
    } else if (!isValidUrl(linkToValidate)) {
      errors.link = "Link must be a valid URL";
    }

    // Only validate image if it's a new banner or if user is changing the image
    if (!isEditing && !image && !bannerData.image) {
      errors.image = "Image is required";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleImageChange = (e) => {
    this.setState({
      [e.target.id]: e.target.files[0],
    });
  };

  handleMobileImageChange = async (e) => {
    try {
      const file = e.target.files[0];
      this.setState({ mobileImageFile: file });
      if (!file) return;
      const token = localStorage.getItem("loginDetails");
      const fd = new FormData();
      fd.append("mobileImage", file);
      const resp = await Axios.post(
        Constant.apiBasePath + "simple-banner/upload-mobile-image",
        fd,
        {
          headers: { token, "Content-Type": "multipart/form-data" },
        }
      );
      if (resp.data && resp.data.status === "Success" && resp.data.url) {
        this.setState({ mobileImageUrl: resp.data.url });
      }
    } catch (err) {
      console.error("Error uploading mobile image:", err);
    }
  };

  /*.................. Integrate API for update banner...............................................*/

  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.validateForm()) return;

    const form_data = new FormData();
    const { name, description, link, image, mobileImageUrl, bannerData } =
      this.state;
    const id = this.props.match.params.id;

    // Use current value or existing value from bannerData
    form_data.append("name", name || bannerData.name);
    form_data.append("description", description || bannerData.description);
    form_data.append("link", link || bannerData.link);

    // Add mobileImage if provided or if editing with existing mobileImage
    const mobileImageToSend = mobileImageUrl || bannerData.mobileImage;
    if (mobileImageToSend) {
      form_data.append("mobileImage", mobileImageToSend);
    }

    // Only append image if there's a new one
    if (image) {
      form_data.append("image", image);
    }

    try {
      const token = localStorage.getItem("loginDetails");
      const url = id
        ? `${Constant.apiBasePath}simple-banner/${id}`
        : `${Constant.apiBasePath}simple-banner`;

      const response = await Axios({
        method: id ? "put" : "post",
        url,
        data: form_data,
        headers: {
          token,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.status === Constant.statusSuccess) {
        $("#gen-message").text(response.data.message);
        $("#gen-message").css("color", "green");
        setTimeout(
          () => this.props.history.push("/simple-banner-management"),
          2000
        );
      }
    } catch (err) {
      console.error("Error submitting banner:", err);
      $("#gen-message").text("Error updating banner");
      $("#gen-message").css("color", "red");
    }
  };

  async getBannerData(id) {
    try {
      const token = localStorage.getItem("loginDetails");
      const response = await Axios.get(
        `${Constant.apiBasePath}simple-banner/${id}`,
        {
          headers: {
            token,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      if (response.data.status === Constant.statusSuccess) {
        this.setState({
          bannerData: response.data.data,
          ERROR: false,
        });
      }
    } catch (error) {
      console.error("Error fetching banner data:", error);
      this.setState({ bannerData: {}, ERROR: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.bannerData !== this.state.bannerData &&
      Object.keys(this.state.bannerData).length > 0
    ) {
      const { name, description, link, image, mobileImage } =
        this.state.bannerData;
      this.setState({
        name: name || "",
        description: description || "",
        link: link || "",
        image: image || null,
        mobileImageUrl: mobileImage || "",
      });
    }
  }

  componentDidMount() {
    let id = this.props.match.params.id;
    if (id !== undefined) {
      this.getBannerData(id);
    }
  }

  /*.................................end API .................................................................*/

  render() {
    const { bannerData, errors, name, description, link } = this.state;
    const btnVal = bannerData.name ? "Update" : "Add";
    const heading = bannerData.name ? "Update Banner" : "Add Banner";
    let image = "";
    let Options = "";
    let duration = "";

    return (
      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/simple-banner-management">
                        Banner Management
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">{heading}</li>
                  </ol>
                </div>
                <h4 className="page-title-heading">{heading}</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <p id="gen-message"></p>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="update" className="update">
                            Name *
                          </label>
                          <input
                            type="text"
                            id="name"
                            className={`form-control ${
                              errors.name ? "is-invalid" : ""
                            }`}
                            onChange={this.handleChange}
                            value={name} // Changed from defaultValue to value
                          />
                          {errors.name && (
                            <div className="invalid-feedback">
                              {errors.name}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="update" className="update">
                            Description *
                          </label>
                          <textarea
                            id="description"
                            rows="4"
                            cols="50"
                            className={`form-control ${
                              errors.description ? "is-invalid" : ""
                            }`}
                            onChange={this.handleChange}
                            value={description} // Changed from defaultValue to value
                          ></textarea>
                          {errors.description && (
                            <div className="invalid-feedback">
                              {errors.description}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="link" className="update">
                            Link (Optional)
                          </label>
                          <input
                            type="text"
                            id="link"
                            className={`form-control ${
                              errors.link ? "is-invalid" : ""
                            }`}
                            onChange={this.handleChange}
                            value={link} // Changed from defaultValue to value
                          />
                          {errors.link && (
                            <div className="invalid-feedback">
                              {errors.link}
                            </div>
                          )}
                          <small className="form-text text-muted">
                            Leave empty if no link is needed
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="updateImage" className="update">
                            Main Image (Desktop) *
                          </label>
                          <input
                            type="file"
                            id="image"
                            name="image"
                            accept="image/png, image/jpg"
                            className={`form-control ${
                              errors.image ? "is-invalid" : ""
                            }`}
                            onChange={this.handleImageChange}
                          />
                          {errors.image && (
                            <div className="invalid-feedback">
                              {errors.image}
                            </div>
                          )}
                          <p id="error-banner-msg"></p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="mobileImage" className="update">
                            Mobile Image
                          </label>
                          <input
                            type="file"
                            id="mobileImage"
                            name="mobileImage"
                            accept="image/png, image/jpg"
                            className="form-control"
                            onChange={this.handleMobileImageChange}
                          />
                          {(this.state.mobileImageFile ||
                            this.state.bannerData.mobileImage) && (
                            <div style={{ marginTop: "10px" }}>
                              <img
                                src={
                                  this.state.mobileImageFile
                                    ? URL.createObjectURL(
                                        this.state.mobileImageFile
                                      )
                                    : this.state.bannerData.mobileImage
                                }
                                alt="Mobile Preview"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      {/* <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="update" className="update">Duration (Duration should be in this format mm:ss)</label>
                                                            <input type="text" id="duration" className="form-control" onChange={this.handleChange} placeholder="mm:ss"
                                                            defaultValue={duration}/>         
                                                    </div>
                                                </div> */}
                    </div>

                    {bannerData.name !== undefined ? (
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-3" id="">
                            <label className="label1" htmlFor="Image">
                              Old Image :
                            </label>
                            <img
                              src={image}
                              alt="ind"
                              id="background-img"
                              width="80"
                              height="60"
                              className="oldImage"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <button type="submit" className="btn btn-info">
                      {btnVal}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddSimpleBanner;
